// extracted by mini-css-extract-plugin
export default {"item":"Rvs7sa"};